// Content taken verbatim from the two portfolio decks provided by Roy Mathew:
// - EdRoy_Consigliere_Portfolio.pdf (enterprise services)
// - Career Advisory Services.pdf (individual career advisory services)

export const ENTERPRISE_SERVICES = [
  {
    slug: "strategic-recruitment",
    kicker: "01",
    title: "Strategic Recruitment & Talent Acquisition",
    tagline:
      "Specialised hiring for leadership, niche technology, GCCs, startups and critical mandates.",
    overview:
      "Deep requirement understanding, market intelligence-led hiring and near-exclusive engagement for critical mandates — delivered through stakeholder-driven execution and faster closure on complex roles.",
    capabilities: [
      "Leadership Hiring",
      "Technology Hiring",
      "Product & Digital Hiring",
      "HR & Business Hiring",
      "Diversity Hiring",
      "Talent Mapping Support",
      "Recruitment Strategy Advisory",
    ],
    approach: [
      "Deep requirement understanding",
      "Market intelligence-led hiring",
      "Near-exclusive engagement for critical mandates",
      "Stakeholder-driven execution",
      "Faster closure on complex roles",
    ],
    outcomes: [
      "Improved quality of hire",
      "Better closure ratio",
      "Faster turnaround",
      "Stronger candidate engagement",
    ],
    image:
      "https://images.unsplash.com/photo-1544036461-d39cd13af2f0?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "managed-workforce",
    kicker: "02",
    title: "Managed Workforce Solutions",
    tagline:
      "End-to-end recruitment, workforce management, deployment & Middle East support.",
    overview:
      "A managed workforce practice covering recruitment, deployment, third-party payroll coordination and Middle East mobilisation — enabling flexible scaling with reduced operational dependency.",
    capabilities: [
      "Recruitment & onboarding",
      "Managed staffing support",
      "Third-party payroll coordination",
      "Workforce administration",
      "Compliance coordination",
      "Employee lifecycle support",
    ],
    approach: [
      "Recruitment & deployment",
      "Visa coordination support",
      "Local compliance support",
      "Workforce mobilization assistance",
      "Regional onboarding coordination",
    ],
    outcomes: [
      "Flexible workforce scaling",
      "Reduced operational dependency",
      "Faster deployment",
      "Simplified management",
    ],
    image:
      "https://images.unsplash.com/photo-1699568542306-ca1ed61891e5?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "hr-technology",
    kicker: "03",
    title: "HR Technology Consulting & Implementation Advisory",
    tagline:
      "Aligning HR operations with technology-driven transformation initiatives.",
    overview:
      "HR functional expertise combined with technology consulting capability — from HRMS implementation and process automation to vendor evaluation, user adoption and governance.",
    capabilities: [
      "HRMS / HCM implementation support",
      "Recruitment technology solutions",
      "Talent management platforms",
      "HR analytics & dashboards",
      "Process automation",
      "Workflow digitization",
      "Vendor evaluation & advisory",
    ],
    approach: [
      "Requirement gathering & process mapping",
      "Implementation coordination",
      "User adoption support",
      "Governance & reporting",
      "Change management",
    ],
    outcomes: [
      "HR functional expertise",
      "Technology consulting capability",
      "Program management",
      "Strong execution orientation",
    ],
    image:
      "https://images.unsplash.com/photo-1775308493694-6f92a6a61714?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "chro-advisory",
    kicker: "04",
    title: "CHRO Advisory & Strategic Change Management",
    tagline:
      "Senior HR transformation & execution support for CHROs and leadership teams.",
    overview:
      "Extended leadership support for CHRO offices — engaged as strategic advisor, transformation lead, interim senior consultant or execution partner for short-term, high-impact assignments.",
    capabilities: [
      "HR transformation programs",
      "Change management initiatives",
      "Organization effectiveness",
      "HR operating model enhancement",
      "Process redesign initiatives",
      "Technology adoption programs",
    ],
    approach: [
      "Strategic advisor",
      "Transformation lead",
      "Interim senior consultant",
      "Execution partner",
      "Extended leadership support for CHRO offices",
    ],
    outcomes: [
      "Short-term high-impact assignments",
      "Execution-driven transformation",
      "Senior consulting capability",
      "Leadership coordination",
    ],
    image:
      "https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "ai-talent-intelligence",
    kicker: "05",
    title: "AI Interview & Talent Intelligence Solutions",
    tagline: "Agentic AI-powered interviewing via Screeners AI partnership.",
    overview:
      "Agentic AI-driven interview workflows with deep subject-matter evaluation, consistent and unbiased assessment, and the ability to run thousands of simultaneous, contextually evolving interviews.",
    capabilities: [
      "AI-powered audio & video interviews",
      "Human-like two-way conversations",
      "Context-aware dynamic questioning",
      "Automated candidate screening",
      "AI-generated scorecards & insights",
      "High-volume / 24×7 capability",
      "ATS & HRMS integration",
      "Analytics-driven hiring decisions",
    ],
    approach: [
      "Agentic AI-driven interview workflows",
      "Deep subject-matter evaluation",
      "Consistent & unbiased assessment",
      "Thousands of simultaneous interviews",
      "Contextually evolving conversations",
      "Real-time conversational AI",
    ],
    outcomes: [
      "Reduced screening effort",
      "Faster hiring turnaround",
      "Improved recruiter productivity",
      "Scalable AI interviewing",
    ],
    image:
      "https://images.unsplash.com/photo-1726425592350-a7f97c155966?auto=format&fit=crop&w=1600&q=80",
  },
];

// Verbatim from Career Advisory Services deck — Slide 2
export const CAREER_STAGES = [
  {
    step: "01",
    title: "Discovery Phase",
    body: "Aligning your personal career aspirations with the current realities of the market.",
  },
  {
    step: "02",
    title: "Preparation Phase",
    body: "Focusing on company-specific readiness and technical storytelling to showcase your ROI.",
  },
  {
    step: "03",
    title: "Positioning",
    body: "Recalibrating LinkedIn and resumes to attract top-tier recruiters and maximize interest.",
  },
  {
    step: "04",
    title: "Evaluation Phase",
    body: "Running rigorous sessions that mimic the pressure of real high-stakes corporate interviews.",
  },
];

// Verbatim from Career Advisory Services deck — Slide 3
export const ENGAGEMENT_PROCESS = [
  { title: "Discovery Call", body: "Deep dive into background and goals." },
  { title: "Professional Eval", body: "Technical assessment." },
  { title: "Strategic Advisory", body: "Market readiness & growth plans." },
  { title: "Asset Optimization", body: "Resume & LinkedIn profile." },
  { title: "Interview Prep", body: "Targeted industry role simulation." },
  { title: "Career Acceleration", body: "Leadership transition aid." },
];

// Verbatim from Career Advisory Services deck — Slide 4
export const CAREER_AUDIENCES = [
  {
    slug: "rookies",
    title: "Rookies & Professionals",
    body: "Focus on foundational positioning and mastering interview basics to clear initial career hurdles.",
    size: "small",
  },
  {
    slug: "senior-managers",
    title: "Senior & Managers",
    body: "Deeper technical evaluations and strategy-heavy advisory to prepare for leadership responsibilities.",
    size: "medium",
  },
  {
    slug: "leadership",
    title: "Leadership & Founders",
    body: "Services pivot toward executive presence, business alignment, and high-impact strategic advisory.",
    size: "large",
  },
  {
    slug: "self-employed",
    title: "Self-Employed / Entrepreneurs",
    body: "Every component is customizable, ensuring you only pay for guidance required to unlock next tiers.",
    size: "medium",
  },
];

// Slide 9 — Why EdRoy Consigliere (verbatim)
export const WHY_EDROY = [
  { title: "20+ Years", body: "Decades of experience across Talent, HR & Technology domains." },
  { title: "Advisory + Execution", body: "Consultative approach combined with hands-on delivery capability." },
  { title: "Niche Expertise", body: "Specialised in difficult, critical and leadership hiring challenges." },
  { title: "HR + Technology", body: "Unique combination of HR functional depth with tech consulting." },
  { title: "Flexible Models", body: "Advisor, transformation lead, interim consultant or execution partner." },
  { title: "AI-Powered", body: "Access to agentic AI interviewing via Screeners AI partnership." },
];

export const CONTACT = {
  email: "mats@edroyconsigliere.com",
  phone: "+91 7982 1800 69",
  website: "www.edroyconsigliere.com",
  founder: "Roy Mathew",
  founderTitle: "HR Consultant · Talent Strategist · HR Technology Advisor",
};
